const validatePassword = (password: string) => {
  const value = password.trim();
  if (!value) {
    return 'Please enter your new password';
  }
  if (value.length < 8) {
    return 'Your password must have at least 8 characters';
  }
  if (!/[a-z]/.test(value)) {
    return 'Your password must have at least one lower-case letter';
  }
  if (!/[A-Z]/.test(value)) {
    return 'Your password must have at least one capital letter';
  }
  if (!/[0-9]/.test(value)) {
    return 'Your password must have at least one number';
  }
  return '';
};

const validateConfirmPassword = (confirmPassword: string) => {
  if (!confirmPassword.trim()) {
    return 'Please reenter your new password';
  }
  return '';
};

const checkMatchPass = (password: string, confirmPassword: string) => {
  if (password.trim() !== confirmPassword.trim()) {
    return 'Your passwords must match (be the same)';
  }
  return '';
};

export { validatePassword, validateConfirmPassword, checkMatchPass };
